import { Component } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { ApplicationState } from '@mews-commander/types';
import { ImageResizeMode } from '@mews/enums';
import { RouterService } from '@mews/framework';
import { MewsAvatar } from '@optimus-web/core';
import { getImageBaseUrl } from '../../../../modules/app/reducers/configuration';

interface Props {
    altText: string;
    imageId?: string;
    imageBaseUrl: string;
    subAltText?: string;
    subImageId?: string;
}

class UserImage extends Component<Props> {
    render() {
        const { imageUrl } = RouterService;
        const { altText, imageId, imageBaseUrl, subImageId, subAltText } = this.props;
        const { CoverExact } = ImageResizeMode;

        const imageSrc = imageId ? imageUrl(imageId, imageBaseUrl, { mode: CoverExact }) : null;
        const subImageSrc = subImageId ? imageUrl(subImageId, imageBaseUrl, { mode: CoverExact }) : null;

        const avatarProps = {
            size: 'medium' as const,
            src: imageSrc as string,
            title: altText,
        };
        const emblemProps = subImageSrc
            ? {
                  src: subImageSrc,
                  title: subAltText,
              }
            : undefined;

        return <MewsAvatar {...avatarProps} emblem={emblemProps} />;
    }
}

export default connect(
    createStructuredSelector<ApplicationState, Pick<Props, 'imageBaseUrl'>>({
        imageBaseUrl: getImageBaseUrl,
    })
)(UserImage);
